import { gql } from '@apollo/client';
import Fragments from '../fragments';

export const USER_INVITATIONS = gql`
  query userInvitations {
    userInvitations {
      id
      name
      email
      status
      created_at
      opportunity {
        ...opportunityCard
      }
    }
  }
  ${Fragments.opportunityCard}
`;

export const COMMITTEE_MEMBER_INVITATIONS = gql`
  query committeeMemberInvitations {
    committeeMemberInvitations {
      id
      name
      email
      status
      created_at
      opportunity {
        ...opportunityCard
      }
    }
  }
  ${Fragments.opportunityCard}
`;